module.exports = __webpack_public_path__ + "img/2.8baa5786.jpg";